import React from "react";
import { CheckListInterface } from "../checkLists";
import { baseUrl } from "../../../../../../../constants/constants";

const CheckList = ({
  id,
  name,
  file_url,
  file_card_url,
  source_link,
}: CheckListInterface) => {
  const [metrikaCounted, setMetrikaCounted] = React.useState(false);
  const handleView = () => {
    if (!metrikaCounted) {
      setMetrikaCounted(true);
      // @ts-ignore
      ym(100105951, "reachGoal", "metodichki-checklist");
    }
  };
  console.log(file_url)
  return (
    <>
      <div className="one-checkList">
        <a
          href={file_url ? `${baseUrl}${file_url}` : source_link}
          onClick={handleView}
          target="_blank"
        >
          <img
            src={`${baseUrl}${file_card_url}`}
            alt="карточка"
            className="manuals-image"
          />
          <p className="manuals-description">{name}</p>
        </a>
      </div>
    </>
  );
};

export default CheckList;
